import { Box, FormControl, InputLabel, MenuItem, Paper, Select, Typography } from '@mui/material';
import React, { useEffect, useMemo, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

import {
  readClientIdFromSearch,
  readFacilityIdFromSearch,
} from '../../finpay-vob-webform/embed-query-params';
import '../../finpay-vob-webform/index';
import { getConfiguration } from '../../shared/configuration/config-settings';

const DEFAULT_CLIENT_ID = '1';
const DEFAULT_FACILITY_ID = '1';

function VobWebformDemoView() {
  const [searchParams] = useSearchParams();
  const containerRef = useRef<HTMLDivElement>(null);
  const config = getConfiguration();

  const { clientId, facilityId } = useMemo(() => {
    const search = window.location.search;
    return {
      clientId: String(
        readClientIdFromSearch(search) ?? DEFAULT_CLIENT_ID
      ),
      facilityId: String(
        readFacilityIdFromSearch(search) ?? DEFAULT_FACILITY_ID
      ),
    };
  }, [searchParams]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }

    const resolvedClientId = String(
      readClientIdFromSearch(window.location.search) ?? DEFAULT_CLIENT_ID
    );
    const resolvedFacilityId = String(
      readFacilityIdFromSearch(window.location.search) ?? DEFAULT_FACILITY_ID
    );

    container.innerHTML = '';
    const element = document.createElement('finpay-vob-webform');
    element.setAttribute('client-id', resolvedClientId);
    element.setAttribute('facility-id', resolvedFacilityId);
    element.setAttribute(
      'instance',
      config.unified_aws_app_gateway_uri.replace(/\/$/, '')
    );
    container.appendChild(element);
  }, [clientId, facilityId, config.unified_aws_app_gateway_uri, searchParams]);

  return (
    <Box sx={{ maxWidth: 720, mx: 'auto', p: 2 }}>
      <Typography variant="h5" gutterBottom>
        VOB Webform Demo
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Query string (case-insensitive): <code>?clientId=</code> and{' '}
        <code>?facilityId=</code>
      </Typography>

      <Paper sx={{ p: 2, mb: 2 }}>
        <FormControl size="small" sx={{ minWidth: 280 }}>
          <InputLabel shrink>Active IDs</InputLabel>
          <Select
            value="info"
            label="Active IDs"
            displayEmpty
            renderValue={() => `client ${clientId} · facility ${facilityId}`}
          >
            <MenuItem value="info" disabled>
              Change via URL and reload, or edit the address bar
            </MenuItem>
          </Select>
        </FormControl>
      </Paper>

      <div ref={containerRef} />
    </Box>
  );
}

export default VobWebformDemoView;
